import { gql, useMutation, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import Button from "../../../Button/Button";
import PortalFooter from "../../../Reactportal/PortalFooter";
import Reactportal from "../../../Reactportal/Reactportal";
import { ErrorToast, SuccessToast } from "../../../ToastComponent/RectHotToast";
import ".././AddVendorAccount.scss";
import LanesPreview from "./FromAndToCitySelection";
import SelectedLanes from "./SelectedLanes";
import CityState from "./CityState";

const CREATE_LANES = gql`
  mutation CreateLaneManagement($createInput: [LaneManagementDetailedInput]!, $AccountId: ID) {
    createLaneManagement(createInput: $createInput, AccountId: $AccountId) {
      message
    }
  }
`;

const ShowSelectedLanes = gql`
  query FindLanesWithUserID($AccountId: ID) {
    FindLanesWithUserID(AccountId: $AccountId) {
      From_Location
      From_Type
      To_Location
      To_Type
      Is_Reverse
    }
  }
`;

export const GET_VEHICLE_CATEGORY_OF_USER = gql`
  query GetAllVehicleCategoryManagement($AccountID: ID) {
    getAllVehicleCategoryManagement(AccountID: $AccountID) {
      _id
      Unique_Id
      VehicleCategoryGroupData {
        _id
        VehicleType
        VehicleCategory {
          _id
          Unique_Id
          Name
          User_ID
          createdAt
          updatedAt
        }
      }
      createdAt
      updatedAt
    }
  }
`;

const UserPreference = ({ show, setShowModal, setPreferedFromCityLane, setPreferedToCityLane, allFieldsData }) => {
  const [PrevData, setPrevData] = useState([]);
  const [open, setOpen] = useState(show);
  const [openPreview, setPreviewModal] = useState(false);
  const [selectedFromCities, setSelectedFromCities] = useState([]);
  const [selectedToCities, setSelectedToCities] = useState([]);
  const [formatedData, setFormatedData] = useState([]);

  const { data } = useQuery(ShowSelectedLanes, {
    variables: { AccountId: allFieldsData?._id },
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });
  const [CreateLanes, { loading: CreateLanesLoading }] = useMutation(CREATE_LANES, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  useEffect(() => {
    let updatedData =
      data?.FindLanesWithUserID?.map((el) => {
        let obj = { ...el };
        delete obj.__typename;
        return obj;
      }) || [];
    setPrevData(updatedData);
  }, [data]);

  useEffect(() => {
    let arr = [];
    let laneSet = new Set();

    for (let from of selectedFromCities) {
      for (let to of selectedToCities) {
        const forwardLane = `${from.Location}->${to.Location}`;
        const reverseLane = `${to.Location}->${from.Location}`;
        if (!laneSet.has(forwardLane) && !laneSet.has(reverseLane)) {
          const forwardEntry = {
            From_Location: from.Location,
            From_Type: from.Type,
            To_Location: to.Location,
            To_Type: to.Type,
            Is_Reverse: true,
          };

          arr.push(forwardEntry);
          laneSet.add(forwardLane);
        }
      }
    }
    setFormatedData(arr);
  }, [selectedFromCities, selectedToCities]);

  const Closeformfunction2 = () => {
    setShowModal();
    setPreferedFromCityLane(selectedFromCities);
    setPreferedToCityLane(selectedToCities);
    setOpen(false);
    setSelectedFromCities([]);
    setSelectedToCities([]);
  };

  const handleAddLanes = (laneData) => {
    setFormatedData(laneData);
    let updatedLaneData = [];
    let matchedPrevData = new Set(); // To track matched PrevData indices
    for (let newLane of laneData) {
      let flag = false;
      for (let i = 0; i < PrevData.length; i++) {
        let prevLane = PrevData[i];
        if (
          ((newLane.From_Location === prevLane.From_Location && newLane.To_Location === prevLane.To_Location) ||
            (newLane.From_Location === prevLane.To_Location && newLane.To_Location === prevLane.From_Location)) &&
          !matchedPrevData.has(i)
        ) {
          updatedLaneData.push(newLane);
          matchedPrevData.add(i);
          flag = true;
          break;
        }
      }
      if (!flag) {
        updatedLaneData.push(newLane);
      }
    }
    PrevData.forEach((prevLane, index) => {
      if (!matchedPrevData.has(index)) {
        updatedLaneData.push(prevLane);
      }
    });
    setPrevData(updatedLaneData);
    setSelectedFromCities([]);
    setSelectedToCities([]);
  };

  const Submit = () => {
    CreateLanes({
      variables: {
        createInput: PrevData,
        AccountId: allFieldsData?._id,
      },
    })
      .then((res) => {
        SuccessToast("Lanes Created Sucessfuly");
        setOpen(false);
        setShowModal();
        setSelectedFromCities([]);
        setSelectedToCities([]);
      })
      .catch((err) => ErrorToast(err.message));
  };

  return (
    <Reactportal
      open={open}
      onClose={Closeformfunction2}
      TypeOfPortal={"User Preference"}
      TypeOfId={"Load Id :"}
      UserRightsPortal=""
      id={""}
    >
      <>
        <div className="maincontainercityes">
          <CityState
            options={["City", "State", "Zone"]}
            title="From"
            selectedData={selectedFromCities}
            setSelectedData={setSelectedFromCities}
            googleSearchValue=""
            setGoogleSearch={() => {}}
          />
          <CityState
            options={["City", "State", "Zone"]}
            title="To"
            selectedData={selectedToCities}
            setSelectedData={setSelectedToCities}
            googleSearchValue=""
            setGoogleSearch={() => {}}
          />
          <>
            {openPreview && formatedData?.length && (
              <LanesPreview
                show={openPreview}
                setShowModal={setPreviewModal}
                setPreferedFromCityLane={setPreferedFromCityLane}
                setPreferedToCityLane={setPreferedToCityLane}
                allFieldsData={allFieldsData}
                FormatedData={formatedData}
                setFormatedData={handleAddLanes}
              />
            )}
          </>
          <>
            <SelectedLanes formatedData={PrevData} setformatedData={setPrevData} />
          </>
        </div>

        <div className="buttonContainer">
          <Button
            text={"Add Lanes"}
            name="modalbutton"
            action={() => {
              setPreviewModal(true);
            }}
            disabled={formatedData?.length ? false : true}
          />
        </div>
      </>
      <PortalFooter
        renderContent={() => <></>}
        disabled={false}
        SaveAndClose={Submit}
        handleformclose={() => {
          Closeformfunction2();
          setOpen(false);
        }}
        Cancletype={"Cancel"}
        loadingState={CreateLanesLoading}
      />
    </Reactportal>
  );
};

export default UserPreference;
